module.exports = __webpack_public_path__ + "img/hamburger-close.ee7803cc.svg";